import { useParams } from 'react-router-dom';
import { ContentWrapper } from '@/widgets/ContentWrapper';
import { CustomBreadcrumbs } from '@/widgets/CustomBreadcrumbs';
import { useGetCertificateByIdQuery } from '@/entities/Certificates';
import { AppImage } from '@/shared/ui/AppImage';
import { usePageTitle } from '@/shared/lib/hooks';
import { Section } from '@/shared/ui/Section';
import { CourseAnalytics } from '../components/CourseAnalytics';
import { CourseStatementOfGrades } from '../components/CourseStatementOfGrades';

export const CertificateView = () => {
  usePageTitle('Certificate');
  const params = useParams();
  const certificateId = params.certificateId || '';
  const { data: certificatesData, isLoading: isCertificatesLoading, error } = useGetCertificateByIdQuery(certificateId, {
    skip: !params.certificateId || Number.isNaN(Number(params.certificateId)),
  });

  const breadcrumbsItems = [
    { label: 'My Profile', href: '/profile' },
    { label: 'Certificates', href: '/profile?tab=certificates' },
    { label: certificatesData?.course?.title ?? '' },
  ];

  return (
    <ContentWrapper
      isLoading={isCertificatesLoading}
      isError={!!error}
      error={error}
      errorMessage="Failed to load certificate information."
      emptyMessage="Certificate information is not available or not found."
      className="flex gap-6 w-full"
    >
      {certificatesData && (
        <>
          <div className="w-full flex-1 flex flex-col gap-6">
            <Section className="flex flex-col gap-6">
              <CustomBreadcrumbs items={breadcrumbsItems} />
              <h2 className="text-[32px] font-medium">{certificatesData.course.title}</h2>
              <div className="w-full max-w-[409px] rounded-[24px] overflow-hidden p-0 min-w-0 h-auto">
                {certificatesData.certificate.imageFile?.url ? (
                  <AppImage
                    src={certificatesData.certificate.imageFile.url}
                    alt={`Certificate ${certificatesData.certificate.certificateNumber}`}
                    className="w-full h-full object-contain"
                  />
                ) : (
                  <div className="w-full aspect-[4/3] rounded-lg bg-neutral-100 flex items-center justify-center">
                    <p className="text-grey-secondary">No certificate image available</p>
                  </div>
                )}
              </div>
            </Section>

            <CourseStatementOfGrades terms={certificatesData.terms ?? []} />
          </div>
          <CourseAnalytics data={certificatesData} />
        </>
      )}
    </ContentWrapper>
  );
};
